import { INavItem } from '@/blocks/sections/Header/data/types';

export function hasSidebar(item: INavItem) {
  return Boolean(item?.subitems?.length || item.widget);
}
